import { z } from "zod";

export const EmailSyncSchema = z.object({
  id: z.string(),
  connectionId: z.string(),
  userId: z.string(),
  lastSyncedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type EmailSync = z.infer<typeof EmailSyncSchema>;

export const EmailSyncsResponseSchema = z.object({
  emailSyncs: z.array(EmailSyncSchema),
});

export type EmailSyncsResponse = z.infer<typeof EmailSyncsResponseSchema>;

export const EmailSyncResponseSchema = z.object({
  emailSync: EmailSyncSchema,
});

export type EmailSyncResponse = z.infer<typeof EmailSyncResponseSchema>;
